/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="14.23"
        height="14.29"
        viewBox="0 0 14.23 14.29"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M679.43,391.37h-3V381.9h3ZM678,380.6a1.73,1.73,0,1,1,1.73-1.73A1.73,1.73,0,0,1,678,380.6Zm12.49,10.77h-2.9v-4.58c0-1.11,0-2.47-1.55-2.47s-1.73,1.17-1.73,2.41v4.7h-2.91V381.9h2.72v1.3h.06a3.09,3.09,0,0,1,2.79-1.54c3,0,3.52,2,3.52,4.51Z"
          transform="translate(-676.21 -377.14)"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'LinkedinIcon';

export default Icon;
